import script from "./PerformerProjectFormStep1.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep1.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep1.vue?vue&type=style&index=0&id=24097f20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24097f20"]])

export default __exports__